import { render, staticRenderFns } from "./DatePicker2.vue?vue&type=template&id=bd0dfcb8&"
import script from "./DatePicker2.vue?vue&type=script&lang=js&"
export * from "./DatePicker2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports